const skillsData = [
    { name: "HTML", icon: "https://cdn-icons-png.flaticon.com/512/732/732212.png" },
    { name: "CSS", icon: "https://cdn-icons-png.flaticon.com/512/732/732190.png" },
    { name: "JavaScript", icon: "https://cdn-icons-png.flaticon.com/512/5968/5968292.png" },
    { name: "React", icon: "https://cdn-icons-png.flaticon.com/512/1126/1126012.png" },
    { name: "Node.js", icon: "https://cdn-icons-png.flaticon.com/512/5968/5968322.png" },
    { name: "MongoDB", icon: "https://cdn-icons-png.flaticon.com/512/919/919836.png" },
    { name: "Git", icon: "https://cdn-icons-png.flaticon.com/512/2111/2111288.png" },
    { name: "Bootstrap", icon: "https://cdn-icons-png.flaticon.com/512/5968/5968672.png" },
    { name: "C++", icon: "https://cdn.jsdelivr.net/npm/simple-icons@v8/icons/cplusplus.svg"},
    { name: "Java", icon: "https://upload.wikimedia.org/wikipedia/en/3/30/Java_programming_language_logo.svg"},
    // { name: "OOPs", icon: ""},
    { name: "Ethereum", icon: "https://cdn.jsdelivr.net/npm/simple-icons@v8/icons/ethereum.svg"},
    { name: "Solidity", icon: "https://cdn.jsdelivr.net/npm/simple-icons@v8/icons/solidity.svg"},
    { name: "Express", icon: "https://cdn.jsdelivr.net/npm/simple-icons@v8/icons/express.svg"},
    { name: "GitHub", icon: "https://cdn.jsdelivr.net/npm/simple-icons@v8/icons/github.svg"},
  ];

  export default skillsData;